import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { tasksApi, CreateTaskPayload } from '../api/tasksApi'
import { toast } from 'react-toastify'

export const useTasks = (statusFilter?: string, pageSize = 200) => {
  const queryClient = useQueryClient()

  const query = useQuery({
    queryKey: ['tasks', 'my', statusFilter, pageSize],
    queryFn:  () => tasksApi.getMyTasks({ status: statusFilter, pageSize }),
  })

  const completeMutation = useMutation({
    mutationFn: (id: string) => tasksApi.complete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tasks'] })
      toast.success('Task completed')
    },
    onError: (err: any) => toast.error(err.message || 'Failed to complete task'),
  })

  const createMutation = useMutation({
    mutationFn: (payload: CreateTaskPayload) => tasksApi.create(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tasks'] })
      toast.success('Task created')
    },
    onError: (err: any) => toast.error(err.message || 'Failed to create task'),
  })

  return {
    tasks:        query.data?.items ?? [],
    isLoading:    query.isLoading,
    error:        query.error,
    refetch:      query.refetch,
    completeTask: completeMutation.mutate,
    isCompleting: completeMutation.isPending,
    createTask:   createMutation.mutate,
    isCreating:   createMutation.isPending,
  }
}
